import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	emojiNodeLabel: {
		id: 'fabric.emoji.label',
		defaultMessage: 'Emoji',
		description: 'Label to indicate emoji node to Screen reader users',
	},
});
